import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
  Duration5ynfiptaqcrg as Duration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  DurationUnit_MINUTES_getInstance33ilufdckt9os as DurationUnit_MINUTES_getInstance,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function item$default(id, maximumAge, pullFrequency, $super) {
  maximumAge = maximumAge === VOID ? Companion_getInstance().INFINITE_1 : maximumAge;
  var tmp;
  if (pullFrequency === VOID) {
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
  } else {
    tmp = pullFrequency;
  }
  pullFrequency = tmp;
  return $super === VOID ? this.item_eropyg_k$(id, maximumAge, pullFrequency) : $super.item_eropyg_k$.call(this, id, new (Duration())(maximumAge), new (Duration())(pullFrequency));
}
function list$default(query, maximumAge, pullFrequency, $super) {
  maximumAge = maximumAge === VOID ? Companion_getInstance().INFINITE_1 : maximumAge;
  var tmp;
  if (pullFrequency === VOID) {
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
  } else {
    tmp = pullFrequency;
  }
  pullFrequency = tmp;
  return $super === VOID ? this.list_wx6i37_k$(query, maximumAge, pullFrequency) : $super.list_wx6i37_k$.call(this, query, new (Duration())(maximumAge), new (Duration())(pullFrequency));
}
function get(id) {
  // Inline function 'kotlin.time.Companion.minutes' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(1, DurationUnit_MINUTES_getInstance());
  return this.item$default_6j9a06_k$(id, VOID, tmp$ret$0);
}
function query(query) {
  // Inline function 'kotlin.time.Companion.minutes' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(1, DurationUnit_MINUTES_getInstance());
  return this.list$default_sjz00l_k$(query, VOID, tmp$ret$0);
}
function watch(id) {
  return this.item$default_6j9a06_k$(id);
}
function watch_0(query) {
  return this.list$default_sjz00l_k$(query);
}
var ModelCacheLikeClass;
function ModelCacheLike() {
  if (ModelCacheLikeClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ModelCacheLike', VOID, VOID, VOID, [1, 0]);
    ModelCacheLikeClass = $;
  }
  return ModelCacheLikeClass;
}
//region block: exports
export {
  get as getejg6weymx5xn,
  query as querywyj590i3eimd,
  watch as watchfa0nguk2p1l7,
  watch_0 as watchq159bzxd0s4v,
  ModelCacheLike as ModelCacheLike1q3b58tuu7jn2,
  item$default as item$default3bjnrg54mh16v,
  list$default as list$defaultxdc7qn6p0xfr,
};
//endregion

//# sourceMappingURL=ModelCacheLike.mjs.map
